<template>
<main-content v-if="$can('read', 'ipg-gateway')">
    <manage-gateways></manage-gateways>
</main-content>
<main-content v-else-if="is_authenticated && create_cart_gateway !== true ">
    <kt-panel>
        <kt-panel-header>
            <kt-panel-header-actions :style="headerAction">
                <div class="dropdown">
                    <button class="btn btn-success dropdown-toggle" type="button" data-toggle="dropdown">
                        {{ $t('gateway.btn.add') + " " }}
                        <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu">
                        <li>
                            <router-link to="/gateways/create">
                                {{ $t('label.create_pardakhtyari_gateway') }}
                            </router-link>
                        </li>
<!--                        <li>-->
<!--                            <router-link to="/dedicated/create">-->
<!--                                {{ $t('label.create_dedicated_gateway') }}-->
<!--                            </router-link>-->
<!--                        </li>-->
<!--                        <li>-->
<!--                            <router-link to="/payman/create">-->
<!--                                {{ $t('label.create_payman_gateway') }}-->
<!--                            </router-link>-->
<!--                        </li>-->
<!--                        <li>-->
<!--                            <router-link to="/ivr/create">-->
<!--                                {{ $t('label.create_ivr_gateway_en') }}-->
<!--                            </router-link>-->
<!--                        </li>-->
<!--                        <li>-->
<!--                            <button type="button" class="btn-link create-cart-gateway" @click="createCartGateway">-->
<!--                                {{ $t('label.create_cart_gateway') }}-->
<!--                            </button>-->
<!--                            <router-link to="/open-banking/deposit/pf/create">-->
<!--                                {{ $t('label.create_deposit_gateway') }}-->
<!--                            </router-link>-->
<!--                            <router-link to="/open-banking/deposit/starshop/create">-->
<!--                                {{ $t('label.create_starshop_deposit_gateway') }}-->
<!--                            </router-link>-->
<!--                        </li>-->
                    </ul>
                </div>
            </kt-panel-header-actions>
        </kt-panel-header>
    </kt-panel>
    <own-gateways></own-gateways>
</main-content>
<main-content v-else-if="create_cart_gateway === true ">
    <loader></loader>
</main-content>
<main-content v-else-if="is_authenticated_pending">
    <kt-panel>
        <kt-panel-body>
            <p class="font-weight-bolder text-center" :style="{fontSize: '15px'}">
                {{ $t('message.authenticated_pending_stil') }}
            </p>
        </kt-panel-body>
    </kt-panel>
</main-content>
<main-content v-else>
    <kt-panel>
        <kt-panel-body>
            <p class="font-weight-bolder text-center" :style="{fontSize: '15px'}">
                {{ $t('message.not_authenticated_stil') }}
                <router-link v-if="profile_completed" 
                    class="btn btn-brand d-block w-25 text-center align-content-center mx-auto mt-3" 
                    to="/profile/authenticate"> {{ $t('complete_authentication') }}</router-link>
                <router-link v-else 
                    class="btn btn-brand d-block w-25 text-center align-content-center mx-auto mt-3" 
                    to="/profile/update"> {{ $t('complete_info') }}</router-link>
            </p>
        </kt-panel-body>
    </kt-panel>
</main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import { mapGetters } from 'vuex'
import ManageGateways from './components/manage-gateways'
import OwnGateways from './components/own-gateways'
import { STAR_CARD_REGISTER } from '@/common/config'
import $ from "jquery";
import Loading from '@/components/custom/loading'
import { gatewayService } from '@/common/api.service'

export default {
    components: {
        'main-content': mainContent,
        'own-gateways': OwnGateways,
        'manage-gateways': ManageGateways,
        'loader': Loading
    },
    data() {
        return {
            headerAction: {
                left: '10px',
                top: '10px',
                position: 'absolute'
            },
            create_cart_gateway: false
        }
    },

    computed: {
        ...mapGetters('user', [
            'is_authenticated', 'is_authenticated_pending', 'profile_completed', 'current_user'
        ]),
    },
    methods: {
        createCartGateway() {
            this.create_cart_gateway = true
            this.addCartGatewayFlag()
            this.RegisterOrLoginToCartPaystar()
        },
        addCartGatewayFlag() {
            gatewayService.addCartGatewayFlag().then(response => {})
        },

        RegisterOrLoginToCartPaystar() {
            var phone;
            var first_name;
            var last_name;
            if (Object.keys(this.current_user).length > 0) {
                phone = this.current_user.phone
                first_name = this.current_user.first_name
                last_name = this.current_user.last_name
            }
            else {
                this.$store.dispatch('user/fetchCurrent').finally(() => {
                    phone = this.current_user.phone
                    first_name = this.current_user.first_name
                    last_name = this.current_user.last_name
                })
            }

            let form = document.createElement('form')

            let input_phone = document.createElement('input')
            input_phone.setAttribute('value', phone)
            input_phone.setAttribute('name', 'phone')

            let input_first_name = document.createElement('input')
            input_first_name.setAttribute('value', first_name)
            input_first_name.setAttribute('name', 'first_name')

            let input_last_name = document.createElement('input')
            input_last_name.setAttribute('value', last_name)
            input_last_name.setAttribute('name', 'last_name')

            form.appendChild(input_phone)
            form.appendChild(input_first_name)
            form.appendChild(input_last_name)
            form.setAttribute('action', STAR_CARD_REGISTER)
            form.setAttribute('method', 'POST')
            document.body.appendChild(form)
            form.setAttribute('style', 'display: none;');
            // this.create_cart_gateway = false
            form.submit()
        }
    },
    mounted() {
    }
}
</script>

<style>
.create-cart-gateway{
    border: none;
    background: none;
    padding-right: 1.2rem;
    padding-top: 9px
}
</style>